module.exports = __webpack_public_path__ + "va.9d57ef0324ca3e9a90a4.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/va.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/va.svg
// module chunks = styles